export enum Language {
  English = 'en',
  German = 'de',
  Spanish = 'es',
  Italian = 'it',
  French = 'fr',
  Portuguese = 'pt',
}

export const defaultLanguage: Language = Language.English

const getCurrentLocale = () => {
  const lang = navigator.language.split('-')[0] as Language

  return Object.values(Language).includes(lang)
    ? lang
    : defaultLanguage
}

export default getCurrentLocale
